import { useTheme } from '../theme/ThemeContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormLabel = ({
  label,
  required,
  htmlFor,
  style
}) => {
  const theme = useTheme();
  const labelStyle = Object.assign({
    fontSize: theme.fontSizes.sm,
    fontWeight: theme.fontWeights.bold,
    color: theme.colors.text
  }, style);
  return /*#__PURE__*/_jsxs("label", {
    htmlFor: htmlFor,
    style: labelStyle,
    children: [label, required && /*#__PURE__*/_jsx("span", {
      style: {
        color: theme.colors.danger
      },
      children: " *"
    })]
  });
};
export default FormLabel;